import React from 'react'

export default function Footer() {
    return (
        <div className="flex justify-center items-center h-16 bg-gray-800 text-white">
            <p>Copyright © 2021 CaféJocha. All rights reserved.</p>
        </div>
    )
}
